import type { AxiosResponse } from 'axios';
import axios from 'axios';
import type { SessionResponse } from '../types/session-response';
import { cacheBuster } from '../../../common/helpers';

export class SessionService {
  static async getSession(force: boolean) {
    return axios
      .get(`/get/settings/session?${cacheBuster(force)}`)
      .then((value: AxiosResponse<SessionResponse>) => value.data);
  }
}
